<template>
  <section class="home-why">
    <div class="container section-value-props hidden">
      <div class="section-header">
        <!-- <span class="subheading">Why We Built INVRS</span> -->
        <h2 class="heading-secondary">Why We Built INVRS</h2>
      </div>
      <div class="grid grid--3-colsrr">
        <div class="value-box hidden">
          <img src="/assets/invrs-why1.png" class="value-icon" /> 
          <!-- <img src="/assets/invrs-education-icon.png" class="value-icon" /> -->
          
          <p class="heading-text">We believe prosperity builds a better future for everyone and creating wealth through long-term investing is a key part of that.</p>
          <!-- <p class="value-description">
            {{$t('why.cultivateText')}}
          </p> -->
        </div>
        <div class="value-box hidden">
          <p class="heading-text">But here's the rub.</p>
        </div>
        <!-- <div class="value-box hidden">
          <img src="../../assets/save-money.png" class="value-icon" />
          <h3 class="heading-tertiary">Save money</h3>
          <p class="value-description">
            Keep your money. Earn premium data and tools for free by using the
            app.
          </p>
        </div> -->
        <div class="value-box hidden">
           <!-- <img src="/assets/invrs-why2.png" class="value-icon" /> -->
          <!-- <h3 class="heading-tertiary">{{$t('why.strengthen')}}</h3> --> 
        
          <p class="heading-text">Everyone <i>says</i> long-term investing matters, but social media noise drowns that out.<br>
            It's all about the hottest stock and short-term gains.
           <br><br>
          When you buy into that story, that’s when you'll veer off course, lose money and waste your precious time - an investor's greatest asset.
          </p>
          <!-- <p class="heading-text">Losing money is discouraging and may leave you feeling that maybe investing just isn’t for you.
          </p> -->
          <!-- <p class="value-description">
           {{$t('why.strengthenText')}}
          </p> -->
        </div>
        <div class="value-box hidden">
          <!-- <img src="/assets/invrs-why3.png" class="value-icon" /> -->
          <!-- <p class="heading-text"><b>Our mission is to change that.</b></p> -->
          <p class="heading-text">
            <!-- We want to make the learning process feel effortless.
            <ul style="margin-left:5rem;">
              <li style="margin-bottom: 1rem;">To make it fun to learn.</li>
              <li style="margin-bottom: 1rem;">To break down the barriers to using real investment research tools.</li>
              <li style="margin-bottom: 1rem;">To offer multiple ways to learn so you can find what clicks.</li>
              
            </ul><br> -->
           <b> Our mission is to give you the skills and confidence to ignore the noise, meet your financial goals and live the life of your dreams.</b>
          <!-- <p class="value-description">
            {{$t('why.investText')}}
          </p> -->
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      valueProps: [],
      obsOptionsValueProps: {
        root: null,
        threshold: 0.3,
      },
      obsOptionsSection: {
        root: null,
        threshold: 0.15,
      },
      section: "",
    };
  },
  mounted() {
    this.valueProps = document.querySelectorAll(".value-box");
    this.section = document.querySelector(".section-value-props");
    const valuePropsObserver = new IntersectionObserver(
      this.revealValueProps,
      this.obsOptionsValueProps
    );
    const sectionObserver = new IntersectionObserver(
      this.revealSection,
      this.obsOptionsSection
    );
    valuePropsObserver.observe(this.section);
    sectionObserver.observe(this.section);
  },
  methods: {
    revealValueProps(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.valueProps.forEach((v, i) => {
            setTimeout(() => v.classList.remove("hidden"), i * 100);
          });
        }
      });
    },
    revealSection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.section.classList.remove("hidden");
        }
      });
    },
  },
};
</script>

<style scoped>
.heading-secondary{
    font-size: 3rem;
}

.home-why {
  padding: 9.6rem 0;
  
}

::v-deep(.container) {
  max-width: 180rem;
}

.section-value-props {
  transition: all 0.3s ease-in;
}

.value-description {
  font-size: 1.8rem;
  line-height: 2.6rem;
}

.value-icon {
  margin-bottom: 1.6rem;
  width: 8.6rem;
  height: 6.4rem;
}

.section-header {
  display: flex;
  flex-direction: column;
}

.value-box {
  transition: all 0.3s ease-in;
}

.hidden {
  transform: translateY(4.8rem);
  opacity: 0;
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  .home-why {
    padding: 5rem 0 5rem 0;
  }
}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .home-why {
    padding: 5rem 5rem 0;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  .value-icon {
    
    
  }

  .home-why {
    padding: 5rem 0 5rem 0;
  }
}
</style>
